import { defineComponent as _defineComponent } from 'vue'
import { NeoRadioButton } from '@kodadot1/brick'


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioSelect',
  props: {
    value: null,
    options: null,
    showEmpty: { type: Boolean },
    separated: { type: Boolean },
    multiline: { type: Boolean },
    rounded: { type: Boolean }
  },
  emits: ['input'],
  setup(__props: any, { emit }) {





const handleInput = (value: string) => {
  emit('input', value)
}

return { __sfc: true,emit, handleInput, NeoRadioButton }
}

})